import styled from 'styled-components';

import Link from '../Link/Link';

export const Spinner = styled.div`
  width: 25px;
  height: 25px;
  border: solid 4px;
  border-right-color: transparent;
  border-radius: 50%;
  animation: rotate-cw;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  @keyframes rotate-cw {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const InternalButton = styled(Link)`
  border-radius: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  text-align: center;
  margin-top: 5px;
  border: none;
  margin-bottom: 0;
  cursor: pointer;
  /* Button sizes */
  &.standard {
    font-weight: 600;
    font-size: 14px;
    min-width: 150px;
    height: 40px;
    padding: 0 12px;
  }
  &.small {
    font-weight: 600;
    font-size: 10px;
    min-width: 9px;
    height: 30px;
    padding: 9px 15px;
  }
  &.large {
    font-weight: 600;
    font-size: 16px;
    min-width: 240px;
    height: 53px;
    padding: 1rem;
  }
  &.slim {
    font-weight: 600;
    font-size: 14px;
    min-width: 140px;
    height: 35px;
    padding: 0 30px;
  }
  /* Button style red to white */
  &.red-to-white {
    background-color: #eb0000;
    box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #ffffff;
    &:hover,
    &:focus {
      background-color: #ffffff;
      color: #eb0000;
    }
    transition:
      background-color 0.3s,
      color 0.3s;
  }
  /* Button style red to black */
  &.red-to-black {
    background-color: #eb0000;
    box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #ffffff;
    &:hover,
    &:focus {
      background-color: #333333;
    }
    transition:
      background-color 0.3s,
      color 0.3s;
  }
  /* Button style red to dark red */
  &.red-to-darkRed {
    background-color: #eb0000;
    box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #ffffff;
    &:hover,
    &:focus {
      background-color: #c70000;
    }
    transition:
      background-color 0.3s,
      color 0.3s;
  }
  /* Button style white to grey */
  &.white-to-grey {
    background-color: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #333333;
    &:hover,
    &:focus {
      background-color: #dbdbdb;
    }
    transition:
      background-color 0.3s,
      color 0.3s;
  }
  &.black {
    background-color: #000000;
    color: #ffffff;
    &:hover,
    &:focus {
      background-color: #202126;
    }
    transition:
      background-color 0.3s,
      color 0.3s;
  }
  /* Button style white with black outline to black */
  &.white-with-black-outline-to-black {
    background-color: #ffffff;
    border: 1px solid #000000;
    // box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #000000;
    &:hover,
    &:focus {
      background-color: #000000;
      color: #ffffff;
    }
    transition:
      background-color 0.3s,
      color 0.3s;
  }
  /* Button style white with black outline to black */
  &.black-with-white-outline-to-white {
    background-color: #000000;
    border: 1px solid #ffffff;
    // box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #ffffff;
    &:hover,
    &:focus {
      background-color: #ffffff;
      color: #000000;
    }
    transition:
      background-color 0.3s,
      color 0.3s;
  }
`;

export const ExternalButton = styled.a`
  border-radius: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  text-align: center;
  margin-top: 5px;
  border: none;
  margin-bottom: 0;
  cursor: pointer;
  /* Button sizes */
  &.standard {
    font-weight: 600;
    font-size: 14px;
    min-width: 150px;
    height: 40px;
  }
  &.small {
    font-weight: 600;
    font-size: 10px;
    min-width: 9px;
    height: 30px;
    padding: 9px 15px;
  }
  &.large {
    font-weight: 600;
    font-size: 16px;
    min-width: 240px;
    height: 53px;
    padding: 1rem;
  }
  &.slim {
    font-weight: 600;
    font-size: 14px;
    min-width: 140px;
    height: 35px;
    padding: 0 30px;
  }
  /* Button style red to white */
  &.red-to-white {
    background-color: #eb0000;
    box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #ffffff;
    &:hover,
    &:focus {
      background-color: #ffffff;
      color: #eb0000;
    }
    transition:
      background-color 0.3s,
      color 0.3s;
  }
  /* Button style red to black */
  &.red-to-black {
    background-color: #eb0000;
    box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #ffffff;
    &:hover,
    &:focus {
      background-color: #333333;
    }
    transition:
      background-color 0.3s,
      color 0.3s;
  }
  /* Button style red to dark red */
  &.red-to-darkRed {
    background-color: #eb0000;
    box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #ffffff;
    &:hover,
    &:focus {
      background-color: #c70000;
    }
    transition:
      background-color 0.3s,
      color 0.3s;
  }
  /* Button style white to grey */
  &.white-to-grey {
    background-color: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #333333;
    &:hover,
    &:focus {
      background-color: #dbdbdb;
    }
    transition:
      background-color 0.3s,
      color 0.3s;
  }
  &.black {
    background-color: #000000;
    color: #ffffff;
    &:hover,
    &:focus {
      background-color: #202126;
    }
    transition:
      background-color 0.3s,
      color 0.3s;
  }
  /* Button style white with black outline to black */
  &.white-with-black-outline-to-black {
    background-color: #ffffff;
    border: 1px solid #000000;
    // box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #000000;
    &:hover,
    &:focus {
      background-color: #000000;
      color: #ffffff;
    }
    transition:
      background-color 0.3s,
      color 0.3s;
  }
  /* Button style white with black outline to black */
  &.black-with-white-outline-to-white {
    background-color: #000000;
    border: 1px solid #ffffff;
    // box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #ffffff;
    &:hover,
    &:focus {
      background-color: #ffffff;
      color: #000000;
    }
    transition:
      background-color 0.3s,
      color 0.3s;
  }
`;

export const FunctionalButton = styled.button`
  border-radius: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  text-align: center;
  margin-top: 5px;
  border: none;
  margin-bottom: 0;
  cursor: pointer;
  /* Button sizes */
  &.standard {
    font-weight: 600;
    font-size: 14px;
    min-width: 150px;
    height: 40px;
  }
  &.small {
    font-weight: 600;
    font-size: 10px;
    min-width: 9px;
    height: 30px;
    padding: 9px 15px;
  }
  &.large {
    font-weight: 600;
    font-size: 16px;
    min-width: 240px;
    height: 53px;
    padding: 1rem;
  }
  &.slim {
    font-weight: 600;
    font-size: 14px;
    min-width: 140px;
    height: 35px;
    padding: 0 30px;
  }
  /* Button style red to white */
  &.red-to-white {
    background-color: #eb0000;
    box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #ffffff;
    &:hover,
    &:focus {
      background-color: #ffffff;
      color: #eb0000;
    }
    transition:
      background-color 0.3s,
      color 0.3s;

    ${Spinner} & {
      border: #ffffff;
      :hover {
        border: #eb0000;
      }
    }
  }
  /* Button style red to black */
  &.red-to-black {
    background-color: #eb0000;
    box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #ffffff;
    &:hover,
    &:focus {
      background-color: #333333;
    }
    transition:
      background-color 0.3s,
      color 0.3s;

    ${Spinner} & {
      border: #ffffff;
    }
  }
  /* Button style red to dark red */
  &.red-to-darkRed {
    background-color: #eb0000;
    box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #ffffff;
    &:hover,
    &:focus {
      background-color: #c70000;
    }
    transition:
      background-color 0.3s,
      color 0.3s;

    ${Spinner} & {
      border: #ffffff;
    }
  }
  /* Button style white to grey */
  &.white-to-grey {
    background-color: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #333333;
    &:hover,
    &:focus {
      background-color: #dbdbdb;
    }
    transition:
      background-color 0.3s,
      color 0.3s;

    ${Spinner} & {
      border: #333333;
    }
  }
  /* Button style white with black outline to black */
  &.white-with-black-outline-to-black {
    background-color: #ffffff;
    border: 1px solid #000000;
    // box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #000000;
    &:hover,
    &:focus {
      background-color: #000000;
      color: #ffffff;
    }
    transition:
      background-color 0.3s,
      color 0.3s;

    ${Spinner} & {
      border: #000000;
    }
  }
  &.black {
    background-color: #000000;
    color: #ffffff;
    &:hover,
    &:focus {
      background-color: #202126;
    }
    transition:
      background-color 0.3s,
      color 0.3s;
  }
  /* Button style white with black outline to black */
  &.black-with-white-outline-to-white {
    background-color: #000000;
    border: 1px solid #ffffff;
    // box-shadow: 0 2px 4px 0 rgba(53, 43, 43, 0.24);
    color: #ffffff;
    &:hover,
    &:focus {
      background-color: #ffffff;
      color: #000000;
    }
    transition:
      background-color 0.3s,
      color 0.3s;

    ${Spinner} & {
      border: #ffffff;
    }
  }
`;
